import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";

@Component({
  selector: "app-historical-status-indicators-report",
  templateUrl: "./historical-status-indicators-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoricalStatusIndicatorsReportComponent  {
  filters: string[];
  dashboardType = LookerRiskDashboardType.HISTORICAL_STATUS_INDICATORS_REPORT;

  constructor() {
    this.filters = ["Projects", "ServiceYear"];
  }
}
